import { tns } from 'tiny-slider/src/tiny-slider';

export default (() => {
  window.galleryInstances = [];

    $('.gallery-slider').each(function() {
      var size = 4;

      if($(this).data('size') < 4 || $(this).data('size') > 1) {
        size = $(this).data('size');

        if($(this).data('size') > 4) {
          size = 4;
        }
      }

        tns({
            container: $(this)[0],
            autoplay: false,
            autoplayButtonOutput: false,
            speed: 2000,
            touch: true,
            controls: true,
            controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
            nav: false,
            loop: false,
            responsive: {
                1: {
                  items: 1,
                },
                768: {
                    items: 2,
                },
                981: {
                  items: 3,
                },
                1260: {
                  items: size,
                },
            },
        })
    });

    $('.gallery-popup-slider').each(function(i) {
      var instance = tns({
                      container: $(this)[0],
                      autoplay: false,
                      autoplayButtonOutput: false,
                      speed: 2000,
                      touch: true,
                      controls: true,
                      controlsText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>'],
                      nav: false,
                      loop: false,
                      gutter: 20,
                      items: 1,
                  })
    
    window.galleryInstances.push(instance);

    var outer = $(this).parents('.gallery-popup-outer');
    
    outer.attr('data-index', i);
  });

  $('.galleries-wrapper .gallery-slider .image').click(function() {
    var wrapper = $(this).parents('.galleries-wrapper');

    window.galleryInstances[wrapper.find('.gallery-popup-outer').data('index')].goTo($(this).data('index'));

    wrapper.find('.gallery-popup-outer').css('display', 'flex');
  })

  $('.close-gallery-popup').click(function() {
    $('.gallery-popup-outer').css('display', 'none');
  });

  $('.gallery-popup-outer .wrapper').click(function(e) {
    e.stopPropagation();
  })
});



// WEBPACK FOOTER //
// ./scripts/components/gallery.js